import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-width": "1.5",
        d: "M9.465 21v-2m4.093 2v-2"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "nonzero",
        d: "M9.977 19v.75h.767V19zM0 11c0 .414.344.75.767.75s.768-.336.768-.75zm1.535 4c0-.414-.344-.75-.768-.75S0 14.586 0 15zm11.512 3.25a.76.76 0 0 0-.768.75c0 .414.344.75.768.75zm7.418-8c0 .414.344.75.768.75a.76.76 0 0 0 .767-.75zm-3.837-6c-.424 0-.768.336-.768.75s.344.75.768.75zM22 14a.76.76 0 0 0-.767-.75.76.76 0 0 0-.768.75zM5.884 4.25c-.424 0-.768.336-.768.75s.344.75.768.75zm2.046 14a.76.76 0 0 0-.767.75c0 .414.343.75.767.75zm6.14 1.5a.76.76 0 0 0 .767-.75.76.76 0 0 0-.767-.75zm-4.093-1.5H3.052v1.5h6.925zm-6.925 0c-.731 0-1.517-.718-1.517-1.855H0c0 1.74 1.26 3.355 3.052 3.355zm2.32-12.5c2.013 0 3.837 1.902 3.837 4.5h1.535c0-3.201-2.298-6-5.372-6zm0-1.5C2.298 4.25 0 7.049 0 10.25h1.535c0-2.598 1.825-4.5 3.837-4.5zM9.21 16v3h1.535v-3zm0-5.75V16h1.535v-5.75zM1.535 11v-.75H0V11zm0 5.395V15H0v1.395zm17.44 1.855h-5.928v1.5h5.927zm1.49-1.825c0 1.12-.774 1.825-1.49 1.825v1.5c1.777 0 3.025-1.601 3.025-3.325zM22 10.25c0-3.201-2.298-6-5.372-6v1.5c2.012 0 3.837 1.902 3.837 4.5zM20.465 14v2.425H22V14zM5.884 5.75H17.14v-1.5H5.884zm2.046 14h6.14v-1.5H7.93z"
      }),
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-width": "1.5",
        d: "M3.837 15h3.07m8.186-6.116V4.411m0 0V1.635c0-.236.172-.439.409-.484l.497-.093a3.35 3.35 0 0 1 1.797.156l.08.03a3.06 3.06 0 0 0 1.779.115.447.447 0 0 1 .554.427v2.221a.515.515 0 0 1-.402.499l-.068.016a3.35 3.35 0 0 1-1.943-.125 3.35 3.35 0 0 0-1.797-.156z"
      })
    ], -1)
  ]))]))
}
export default { render: render }